import axios from 'axios'
import { useAuthStore } from '../store/authStore'

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
})

let isRefreshing = false
let pendingQueue = []

function drainQueue() {
  pendingQueue.forEach((cb) => cb())
  pendingQueue = []
}

client.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config

    // Handle frozen / banned accounts
    if (error.response?.status === 403) {
      const detail = error.response.data?.detail
      const path = window.location.pathname
      if (detail?.code === 'FROZEN' && path !== '/profile' && !path.startsWith('/support')) {
        window.location.href = '/profile'
        return Promise.reject(error)
      }
      if (detail?.code === 'BANNED' && path !== '/banned') {
        const reason = encodeURIComponent(detail.reason || '')
        window.location.href = `/banned?reason=${reason}`
        return Promise.reject(error)
      }
    }

    if (error.response?.status !== 401 || original._retry) {
      return Promise.reject(error)
    }

    // Refresh request itself failed — session is dead
    if (original.url?.includes('/api/auth/refresh')) {
      if (useAuthStore.getState().isAuth) {
        useAuthStore.getState().logout()
        window.location.href = '/login'
      }
      return Promise.reject(error)
    }

    // Unauthenticated user hitting a protected endpoint — just reject
    if (!useAuthStore.getState().isAuth) {
      return Promise.reject(error)
    }

    original._retry = true

    if (isRefreshing) {
      return new Promise((resolve) => {
        pendingQueue.push(() => resolve(client(original)))
      })
    }

    isRefreshing = true
    try {
      await client.post('/api/auth/refresh')
      isRefreshing = false
      drainQueue()
      return client(original)
    } catch (refreshError) {
      isRefreshing = false
      pendingQueue = []
      useAuthStore.getState().logout()
      window.location.href = '/login'
      return Promise.reject(refreshError)
    }
  }
)

export default client

export function getErrMsg(err, fallback = 'Ошибка') {
  const d = err?.response?.data?.detail
  if (!d) return fallback
  if (typeof d === 'string') return d
  if (typeof d === 'object' && d.detail) return d.detail
  return fallback
}
